// extracted by mini-css-extract-plugin
export default {"history":"ScheduleHistory_history__zFdw0","historyFooter":"ScheduleHistory_historyFooter__w-Slp","tableLink":"ScheduleHistory_tableLink__nDeWz"};